import { useMemo } from "react";
import { DateTime } from "luxon";
import { Column } from "react-table";
import { GetBlockchainAnimalDataByKillNumber_blockchainAnimalDataByKillNumber_movements } from "api/Blockchain/types/GetBlockchainAnimalDataByKillNumber";
import { GetBlockchainAnimalDataByPassport_blockchainAnimalDataByPassport_movements } from "api/Blockchain/types/GetBlockchainAnimalDataByPassport";
import { Spacer, Table, Text, Title } from "components";
import { TABLE_IDS } from "constants/Interface";
import { AnimalDataTypes } from "../";

type AnimalMovementsType =
  | GetBlockchainAnimalDataByPassport_blockchainAnimalDataByPassport_movements
  | GetBlockchainAnimalDataByKillNumber_blockchainAnimalDataByKillNumber_movements;

interface BlockchainAnimalMovementsTableProps {
  movements: AnimalDataTypes["movements"];
}

const COLUMN_IDS = {
  FROM_HOLDING_ID: "fromHoldingId",
  FROM_NAME: "fromFarmName",
  TO_HOLDING_ID: "toHoldingId",
  TO_NAME: "toOwnerName",
  TO_OWNER_ID: "toOwnerId",
  DATE: "date",
  CREATED_BY: "createdBy",
};

export const BlockchainAnimalMovementsTable: React.FC<BlockchainAnimalMovementsTableProps> = ({ movements }) => {
  const data = useMemo(() => movements, []);

  //@ts-expect-error
  const columns: Column<AnimalMovementsType>[] = useMemo(
    () => [
      {
        id: COLUMN_IDS.FROM_HOLDING_ID,
        Header: "From Holding Id",
        accessor: "fromHoldingId",
      },
      {
        id: COLUMN_IDS.FROM_NAME,
        Header: "From Name",
        accessor: "fromFarmName",
      },
      {
        id: COLUMN_IDS.TO_HOLDING_ID,
        Header: "To Holding Id",
        accessor: "toHoldingId",
      },
      {
        id: COLUMN_IDS.TO_NAME,
        Header: "To Name",
        accessor: "toOwnerName",
      },
      {
        id: COLUMN_IDS.TO_OWNER_ID,
        Header: "To Id",
        accessor: "toOwnerId",
      },
      {
        id: COLUMN_IDS.DATE,
        Header: "Date",
        accessor: "date",
        Cell: ({ row }) =>
          row.values[COLUMN_IDS.DATE] ? DateTime.fromISO(row.values[COLUMN_IDS.DATE]).toLocaleString() : "\u2014",
      },
      {
        id: COLUMN_IDS.CREATED_BY,
        Header: "Created By",
        accessor: "createdBy",
      },
    ],
    [],
  );

  return (
    <>
      <Title secondary>Movements</Title>

      <Spacer baselineHeight={1} />

      {data?.length ? (
        <Table<AnimalMovementsType> columns={columns} data={data} tableId={TABLE_IDS.BLOCKCHAIN_ANIMAL_MOVEMENTS} />
      ) : (
        <Text smallest>
          <em>No Movement Data for this Animal</em>
        </Text>
      )}
    </>
  );
};
